import { Text } from '@visx/text';
import styled from 'styled-components';

const TickLabelText = styled(Text)`
    fill: ${({ theme }) => theme.neutral_3};
    font-weight: ${({ theme }) => theme.fontRegular};
    font-size: ${({ theme }) => theme.fontSize_sm};
    font-family: ${({ theme }) => theme.style_primary};
    text-transform: uppercase;
`;

function TickLabel({ formattedValue, dy, textAnchor, x, y }) {
    return (
        <TickLabelText dy={dy} x={x} y={y} textAnchor={textAnchor}>
            {formattedValue}
        </TickLabelText>
    );
}

export default TickLabel;
